import { DataLineageNode } from '@y42/json-schema';
import { DataLineageDiagramGitModel, DataLineageDiagramUIModel } from '../data-lineage-diagram.model';

export const sanitizeLineageModel = (model: DataLineageDiagramUIModel): DataLineageDiagramGitModel => {
  const entityNodes = model.nodeDataArray.map((n) => {
    const gitNode: DataLineageNode = {
      key: n.key,
      category: n.category,
      location: n.location,
      isGroup: n.isGroup,
      group: n.group,
      isSubGraphExpanded: n.isSubGraphExpanded,
    };

    return gitNode;
  });

  const links = model.linkDataArray.map((n) => ({ from: n.from, to: n.to }));

  return {
    nodeDataArray: entityNodes,
    visualDataArray: model.visualDataArray,
    linkDataArray: links,
  };
};
